import { AuthServiceV4 } from '@oneaudi/audi-auth-service';

interface AuthEventData {
  isAuthenticated: boolean;
  userId: string;
}

const getAuthUserData = async (
  authService: AuthServiceV4,
): Promise<AuthEventData> => {
  const isAuthenticated = await authService.isAuthenticated();
  let userId = '';

  if (isAuthenticated) {
    userId = (await authService.getUserInfo()).sub ?? '';
  }

  return {
    isAuthenticated,
    userId,
  };
};

export const processAuthService = async (
  authService: AuthServiceV4,
): Promise<void> => {
  if (document) {
    const { isAuthenticated, userId } = await getAuthUserData(authService);

    const userAuthEvent = new CustomEvent('AUTH-ON-PAGE-LOAD-EVENT', {
      detail: { isAuthenticated: isAuthenticated, userId: userId },
    });

    document.dispatchEvent(userAuthEvent);
  }
};
